import { render, staticRenderFns } from "./ButtonDocument.vue?vue&type=template&id=ffcd3fd8&scoped=true&"
import script from "./ButtonDocument.vue?vue&type=script&lang=js&"
export * from "./ButtonDocument.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDocument.vue?vue&type=style&index=0&id=ffcd3fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcd3fd8",
  null
  
)

export default component.exports